import { useViewContext } from "@folksam/ui/providers/ViewContext";

import { Heading, Paragraph } from "../atoms";
import { Flex } from "../cores";
import { IconFargBetyg } from "../icons";
import { IKeyStringAndValue } from "../types/Types";

interface IFilterDescription {
  filterOptions: IKeyStringAndValue;
}
const FilterDescription = ({ filterOptions }: IFilterDescription) => {
  const { isDesktop, isLargeDesktop } = useViewContext();
  const sverige =
    "Resultatet för hela Sverige redovisar en samlad bedömning av hur färgerna klarat sig på riksnivå.";
  const vindeln =
    "Vindeln utanför Umeå har klart minst mögelpåväxt av de fyra teststationerna. Det beror på mindre fuktigt klimat, kallare vintrar och kortare tillväxtsäsong för mögelsporer.";
  const uppsala =
    "Uppsala visar generellt mindre tillväxt av mögel än i Borås och Alnarp men ändå så pass mycket för vissa färger att det måste betraktas som ett problem.";
  const boras =
    "Teststationen i Borås uppvisar mest mögelpåväxt av de fyra stationerna, tätt följd av Alnarp. Mögel trivs i fukt och det är heller inte ovanligt att det regnar i Borås.";
  const alnarp =
    "Teststationen i Alnarp (nära Malmö) visar på relativt kraftig mögelpåväxt för många färger, näst intill lika mycket som i Borås. Kortare vintrar och luftfuktighet påverkar resultatet.";
  const sverigeHeading = "Hela Sverige";
  const vindelnHeading = "Vindeln (Umeå)";
  const uppsalaHeading = "Uppsala";
  const borasHeading = "Borås";
  const alnarpHeading = "Alnarp (Malmö)";
  return (
    <Flex sx={{ flexDirection: "column", margin: "md" }}>
      <Heading as={"h2"} variant={isDesktop || isLargeDesktop ? "h4" : "h5"}>
        {(filterOptions as IKeyStringAndValue)["omrade"] === "Alnarp (Malmö)"
          ? alnarpHeading
          : (filterOptions as IKeyStringAndValue)["omrade"] === "Uppsala"
          ? uppsalaHeading
          : (filterOptions as IKeyStringAndValue)["omrade"] === "Vindeln (Umeå)"
          ? vindelnHeading
          : (filterOptions as IKeyStringAndValue)["omrade"] === "Boras"
          ? borasHeading
          : sverigeHeading}
      </Heading>
      <Paragraph marginBottom={"lg"}>
        {(filterOptions as IKeyStringAndValue)["omrade"] === "Alnarp (Malmö)"
          ? alnarp
          : (filterOptions as IKeyStringAndValue)["omrade"] === "Uppsala"
          ? uppsala
          : (filterOptions as IKeyStringAndValue)["omrade"] === "Vindeln (Umeå)"
          ? vindeln
          : (filterOptions as IKeyStringAndValue)["omrade"] === "Boras"
          ? boras
          : sverige}
      </Paragraph>
      <Flex>
        <Flex sx={{ marginRight: "md" }}>
          <IconFargBetyg value={"1"} />
          <Paragraph>&#x3D; Bra val</Paragraph>
        </Flex>
        <Flex sx={{ marginRight: "md" }}>
          <IconFargBetyg value={"2"} />
          <Paragraph>&#x3D; Tveksamt val</Paragraph>
        </Flex>
        <Flex>
          <IconFargBetyg value={"3"} />
          <Paragraph> &#x3D; Rekommenderas ej</Paragraph>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default FilterDescription;
